<template>
  <div class="questions-cccordion">
    <div
      v-for="(panel, index_1) in questions"
      :key="index_1"
      class="panel"
    >
      <div
        class="panel-title"
        :class="{ active: activePanel === index_1 }"
        @click="setActivity(index_1)"
      >
        {{ panel.question }}
        <ChervonIcon
          class="chevron"
          fill="#656F82"
        />
      </div>
      <div
        class="panel-body"
        :ref="'panel' + index_1"
      >
        <div
          class="panel-content"
          v-html="panel.answer"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChervonIcon from '@/components/icons/ChevronIcon';

export default {
  name: 'QuestionsAccordion',

  components: {
    ChervonIcon,
  },

  mounted() {
    window.addEventListener('resize', this.resizeHandler);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  },

  data() {
    return {
      activePanel: null,
      timeout: null,
    };
  },

  computed: {
    questions() {
        return [
        {
          question: this.__('website.tariffs.faq.Q1_header'),
          answer: this.__('website.tariffs.faq.Q1_text'),
        },
        {
          question: this.__('website.tariffs.faq.Q2_header'),
          answer: this.__('website.tariffs.faq.Q2_text'),
        },
        {
          question: this.__('website.tariffs.faq.Q3_header'),
          answer: this.__('website.tariffs.faq.Q3_text'),
        },
        {
          question: this.__('website.tariffs.faq.Q4_header'),
          answer: this.__('website.tariffs.faq.Q4_text'),
        },
        {
          question: this.__('website.tariffs.faq.Q5_header'),
          answer: this.__('website.tariffs.faq.Q5_text'),
        },
      ];
    },
  },

  methods: {
    setActivity(panelIndex) {
      const panel = this.getPanel(panelIndex);

      if (!panel) return;

      if (this.activePanel === panelIndex) {
          panel.style.maxHeight = 0;
          this.activePanel = null;
      } else {
        if (this.activePanel !== null) {
          const prevPanel = this.getPanel(this.activePanel);
          if (prevPanel) prevPanel.style.maxHeight = 0;
        }

        panel.style.maxHeight = panel.scrollHeight + 'px';
        this.activePanel = panelIndex;
      }
    },

    resizeHandler() {
      if (this.timeout) window.cancelAnimationFrame(this.timeout);
	
      this.timeout = window.requestAnimationFrame(() => {
        if (this.activePanel) {
          const panel = this.getPanel(this.activePanel);
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    },

    getPanel(index) {
      const ref = this.$refs['panel' + index];

      return ref && ref[0];
    },
  },
};
</script>

<style lang="sass" scoped>
.questions-cccordion
  width: 54%
.panel
  background: #EFF2F7
  border-radius: 10px
  color: #2C2C2C
  overflow: hidden
  user-select: none
  & + .panel
    margin: 8px 0 0
  .panel-title
    padding: 16px 50px 16px 32px
    font-size: 18px
    line-height: 32px
    font-weight: 500
    cursor: pointer
    transition: background .25s
    position: relative
    &.active
      .chevron
        transform: rotate(180deg)
    &:hover
      background: #E4E8EF
    .chevron
      position: absolute
      top: 50%
      margin: -5px 0 0
      right: 26px
      transition: transform .25s
  .panel-body
    max-height: 0
    transition: max-height 0.2s ease-out
    font-size: 16px
    line-height: 28px
    margin: 0 32px
  .panel-content
    padding: 16px 0 24px
    border-top: 1px solid #BCC4D2
    &::v-deep
      p + p
        margin: 16px 0 0

@media screen and (max-width: 990px)
  .questions-cccordion
    width: 100%
  .panel-title
    line-height: 27px
</style>